module.exports = __webpack_public_path__ + "static/media/logo_footer.0431fadd.svg";